/* eslint-disable import/prefer-default-export */
import { User, UserRole } from "../api/types";

export const isAdmin = (user: User | null) =>
  user?.role === UserRole.ADMIN ||
  user?.role === UserRole.MANAGER ||
  user?.role === UserRole.MASTER;

export const isMaster = (user: User | null) => user?.role === UserRole.MASTER;

export const isManager = (user: User | null) => user?.role === UserRole.MANAGER;
